export function shouldStopCourseListInfiniteScroll(
  filterKey: string | undefined,
  isLastUserCourse: boolean,
  criteria?: { active: boolean; isLastFilteredUserCourse: boolean },
): boolean {
  // Page-level filter tabs re-fetch page 1 themselves; nothing to page here.
  if (filterKey) return true;
  // Active list criteria paginate over the server's filtered ordering and
  // carry their own end-of-list accounting.
  if (criteria?.active) return criteria.isLastFilteredUserCourse;
  return isLastUserCourse;
}
